export function timeToMinutes(time) {
    let [hours, minutes] = time.split(':');
    hours = parseInt(hours);
    minutes = parseInt(minutes);
    return hours * 60 + minutes;
}
